module.exports = __webpack_public_path__ + "static/media/RP_Banner.d65e71ea.png";